import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import {
    domainName,
    processApi
} from "../../../../utility/index"
import DriverSwiping from './MessageDetails/DriverSwiping.vue';
import signature from './MessageDetails/signature.vue';
import moment from "moment";

export default {
    components: {
        iTable,
        IPagination,
        DriverSwiping,
        signature
    },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                spotCheckType: '',
                checkTime: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }
            ],
            typeList: [{
                id: '',
                name: this.$t('common.all')
            }, {
                id: '0',
                name: this.$t('SafeManagement.Checked')
            }, {
                id: '1',
                name: this.$t('SafeManagement.Unchecked')
            }],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "carId",
                label: this.$t('common.carId'),
                align: "center",
            },
            {
                prop: "manufactureNum",
                label: this.$t('common.manufactureNum'),
                align: "center",
                width: "150px"
            },
            {
                prop: "customNum",
                label: this.$t('common.customNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "plateNum",
                label: this.$t('common.plateNum'),
                align: "center",
                width: "120px"
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",
                width: "200px"
            },
            {
                prop: "spotCheckDate",
                label: this.$t('SafeManagement.spotCheckDate'),
                align: "center",
                width: "160px",
                // render: (h, params) => {
                //     return h('span', this.$formatDate(params.row.spotCheckDate))
                // }
            },
            {
                prop: "spotCheckType",
                label: this.$t('SafeManagement.spotCheckType'),
                align: "center",
                width: "120px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: {
                            type: params.row.spotCheckType === '' ? '' : params.row.spotCheckType === 0 ? 'success' : 'danger'
                        }
                    }, params.row.spotCheckType === '' ? '' : params.row.spotCheckType === 0 ? this.$t('SafeManagement.Checked') : this.$t('SafeManagement.Unchecked'))
                }

            }
            ],
            dialogDetailsFormVisible: false,
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            innerVisible: false,
            formLabelWidth: '130px',
            diaTitle: '',
            btnType: '',
            rules: {
                carMileage: [{
                    required: true,
                    message: this.$t('SafeManagement.form.pleaseEnterKilometers'),
                    trigger: 'blur'
                }],
            },
            form: {
                whetherSupplement: 0,
                spotCheckDate: '',
                carUseState: '',
                radioList: [],
                carMileage: '',
                phone: '',
                remarks: '',
                filePath: '',
                checkContentStr: '',
                checkFile: ''
            },
            UseStateList: [{
                id: '0',
                name: this.$t('common.normal')
            }, {
                id: '1',
                name: this.$t('SafeManagement.stop')
            }, {
                id: '2',
                name: this.$t('SafeManagement.stoped')
            }],
            pickerOptions: {
                disabledDate(time) {
                    const now = new Date();
                    const yesterday = new Date(now);
                    const weekday = new Date(now);
                    yesterday.setDate(now.getDate() - 1);
                    weekday.setDate(now.getDate() - 8);
                    const yesterdayTimestamp = yesterday.getTime();
                    const weekdayTimestamp = weekday.getTime();
                    return time.getTime() > yesterdayTimestamp || time.getTime() < weekdayTimestamp;
                },
            },
            selected: [],
            orgId: '',
            imageUrl: '',
            dialogVisible: false,
            processImg: processApi,
            FileList: [],
            filePath: '',
            dialogSignatureFormVisible: false,
            isShow: true,
            isDisplay: false
        }
    },

    mounted() {
        if (this.form.checkFile) {
            this.isShow = false
        } else {
            this.isShow = true
        }
    },
    methods: {
        getCheckList() {
            const startTime = this.formInline.checkTime[0]
            const endTime = this.formInline.checkTime[1]
            let param = {
                orgId: Number(this.orgId),
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                startTime: startTime,
                endTime: endTime,
                spotCheckType: this.formInline.spotCheckType,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('checkManagement/GET_SELECTSPOTCHECK', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getCheckList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                spotCheckType: '',
                checkTime: [],
            }
            this.getCheckList()
        },
        getCarCheck() {
            let param = {
                companyId: sessionStorage.getItem('companyId'),
            }
            this.$store.dispatch('checkManagement/GET_SELECTCARCHECK', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.form.radioList = res.data.data
                    }
                }
            })
        },
        addCheck() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('SafeManagement.check')
            this.btnType = 'add'
            this.FileList = []
            this.form.spotCheckDate = moment().format("YYYY-MM-DD")
            this.getCarCheck()
            this.$nextTick(() => {
                this.$refs.form.resetFields()
                this.isShow = true
                this.form.checkFile = ''
                this.isDisplay = false
            })
        },
        changeRadio(val) {
            let arr = this.form.radioList.map(k => {
                return k.isWarning
            })
            let result = arr.some(item => {
                return item == 1
            })
            if (result === true) {
                this.isDisplay = true
            } else {
                this.isDisplay = false
            }
        },
        isSubmit(submitType) {
            let param = {
                submitType: submitType,
                companyId: sessionStorage.getItem('companyId'),
                carId: this.selected[0].carId,
                whetherSupplement: Number(this.form.whetherSupplement),
                spotCheckDate: this.form.spotCheckDate,
                carUseState: this.form.carUseState,
                carMileage: this.form.carMileage,
                remark: this.form.remarks,
                filePath: this.form.filePath,
                checkFile: this.form.checkFile,
                phone: this.form.phone,
                checkContentStr: this.form.radioList.map(k => {
                    return k.isWarning
                }).join(',')
            }
            this.$store.dispatch('checkManagement/GET_INSERTSPOTCHECK', param).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(this.$t('SafeManagement.form.checkSuccess'))
                    this.dialogFormVisible = false;
                    // this.innerVisible = false;
                    this.getCheckList();
                    this.closeDia();
                } else {
                    this.$message.error(res.data.msg)
                }

            }).catch(err => { })
        },

        submitForm(formName, submitType) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let arr = this.form.radioList.map(k => {
                        return k.isWarning
                    })
                    let result = arr.every(item => {
                        console.log(item)
                        return item == 0
                    })
                    console.log(result)
                    if (result === false) {
                        if (this.form.carUseState === '0' || this.form.remarks === '') {
                            // this.innerVisible = true
                            this.$confirm(`${this.$t('SafeManagement.form.ThereAreAbnormalItemsInTheProjectYouSubmittedWhetherToSubmit')}`, `${this.$t('common.btn.hint')}`, {
                                cancelButtonText: `${this.$t('common.btn.cancel')}`,
                                confirmButtonText: `${this.$t('common.btn.confirm')}`,
                                type: 'warning'
                            }).then(res => {
                                this.isSubmit(submitType)
                            }).catch(err => {

                            })
                        } else {
                            // this.innerVisible = false
                            this.isSubmit(submitType)
                        }

                    } else {
                        this.isSubmit(submitType)
                    }
                }
            });
        },

        handlePictureCardPreview(file) {
            this.imageUrl = file.url;
            this.dialogVisible = true;
        },
        handleRemove(file, fileList) {
            this.FileList = []
            const arr = []
            fileList.map((item) => {
                this.FileList.push({
                    name: item.name,
                    url: item.url,
                    uid: item.uid
                })
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },

        handleAvatarSuccess(res, file) {
            const arr = []
            this.FileList.push({
                url: res[0],
            })
            this.FileList.map(item => {
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                whetherSupplement: 0,
                spotCheckDate: moment().format("YYYY-MM-DD"),
                carUseState: '',
                radioList: [],
                carMileage: '',
                phone: '',
                remarks: '',
                filePath: '',
                checkContentStr: '',
                checkFile: ''
            }
        },
        closeDia() {
            this.form = {
                whetherSupplement: 0,
                spotCheckDate: moment().format("YYYY-MM-DD"),
                carUseState: '',
                radioList: [],
                carMileage: '',
                phone: '',
                remarks: '',
                filePath: '',
                checkContentStr: '',
                checkFile: ''
            }
            this.dialogFormVisible = false;
        },

        btnSignature() {
            // this.$router.push({
            //     path: './MessageDetails/signature.vue',
            //  })
            this.dialogSignatureFormVisible = true
            this.$refs.signature.imageUrl = ''
            this.$refs.signature.clearCanvas()
        },
        previewImage() {
            this.dialogSignatureFormVisible = true
            this.$refs.signature.imageUrl = ''
            this.$refs.signature.clearCanvas()
        },

        saveAsImage(data) {
            this.form.checkFile = data
        },

        submitSignatureForm() {
            this.dialogSignatureFormVisible = false
            this.$refs.signature.saveAsImage()
            if (this.form.checkFile) {
                this.isShow = false
            } else {
                this.isShow = true
            }
        },

        cancleSignature() {
            this.dialogSignatureFormVisible = false
        },

        viewReport() {
            this.dialogDetailsFormVisible = true
            this.$nextTick(() => {
                this.$refs.carIdSwiping.bindCarId = this.selected[0].carId
                this.$refs.carIdSwiping.getDriverSwipingCard()
            })
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getCheckList();
        },
        down() {
            if (domainName) {
                const startTime = this.formInline.checkTime[0]
                const endTime = this.formInline.checkTime[1]
                if (domainName.split(":")[0] !== "localhost") {
                    let url = `https://${domainName}/v1/getExportExcel/exportSpotCheck?orgId=${this.orgId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&spotCheckType=${this.formInline.spotCheckType}&startTime=${startTime}&endTime=${endTime}`;
                    location.href = url;
                } else {
                    let host = "localhost:8080";
                    let url = `https://${host}/v1/getExportExcel/exportSpotCheck?orgId=${this.orgId}&selectCarType=${this.formInline.selectCarType}&selectCarValue=${this.formInline.selectCarValue}&spotCheckType=${this.formInline.spotCheckType}&startTime=${startTime}&endTime=${endTime}`;
                    location.href = url;
                }
            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}